export interface IUser {
	id: number
	name: string
	email: string
	affiliate_code: string | null
	discount_codes_given: number
	is_affiliate: boolean
	avatar: string
	phone: string
	birthday: string
	path_image: string
	email_verified_at: string | null
	created_at: string
	updated_at: string
	occupation: string | null
	gender: string | null
}

export const initialUserProfile: IUser = {
	id: 0,
	name: "",
	email: "",
	affiliate_code: null,
	discount_codes_given: 0,
	is_affiliate: false,
	avatar: "",
	phone: "",
	birthday: "",
	path_image: "",
	email_verified_at: null,
	created_at: "",
	updated_at: "",
	occupation: null,
	gender: null,
}
